export default "__VITE_ASSET__BwGs68MO__"